export const isNavSourceFromApp = (navSource: string | undefined) =>
  navSource === 'app'
